import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/archive`;

/**
 * Fetch available archive models
 */
export const fetchArchiveModels = async () => {
  const response = await axios.get(`${API_URL}/models`);
  return response.data;
};

/**
 * Start a new archive job (fire-and-forget)
 * Returns immediately with jobId
 * @param {object} payload - { models, all, cutoffDate, yearsBack, dryRun }
 * @returns {Promise<{ success: boolean, jobId: string, status: string, message: string }>}
 */
export const startArchive = async (payload) => {
  const response = await axios.post(`${API_URL}/run`, payload);
  return response.data;
};

/**
 * Get the status of an archive job
 * @param {string} jobId - The job ID to check
 * @returns {Promise<object>} Job status object
 */
export const getArchiveStatus = async (jobId) => {
  const response = await axios.get(`${API_URL}/status/${jobId}`);
  return response.data;
};

/**
 * List all archive jobs
 * @returns {Promise<object>} Jobs list
 */
export const listArchiveJobs = async () => {
  const response = await axios.get(`${API_URL}/jobs`);
  return response.data;
};

/**
 * @deprecated Use startArchive instead - kept for backwards compatibility
 */
export const runArchive = startArchive;

export default {
  fetchArchiveModels,
  startArchive,
  getArchiveStatus,
  listArchiveJobs,
  runArchive
};
